import { createFileRoute } from '@tanstack/react-router';

import { SupportTab } from '@/components/settings/support/support-tab';
import { supportSearchSchema } from '@/components/settings/support/support-topic';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/_authenticated/support')({
  validateSearch: supportSearchSchema,
  loader: () => loadNamespaces('support'),
  staticData: {
    title: 'route.support.title',
  },
  component: SupportTab,
});
